export const tipoFormularioRualList = [
    [
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" },
        { "grupo": "", "descricao": "" }

    ],
    [

        { "grupo": "", "descricao": "Aptidão Boa" },
        { "grupo": "", "descricao": "Aptidão Regular" },
        { "grupo": "", "descricao": "Aptidão Restrita" },
        { "grupo": "", "descricao": "Pastagem Plantada" },
        { "grupo": "", "descricao": "Silvicultura|Pastagem Natural" },
        { "grupo": "", "descricao": "Preservação da Fauna/Flora" }

    ],
    [
        { "grupo": "Topografia", "descricao": "Planas" },
        { "grupo": "Destinação", "descricao": "Agricultura" },
        { "grupo": "Topografia", "descricao": "Altas" },
        { "grupo": "Destinação", "descricao": "Pecuária" },
        { "grupo": "Topografia", "descricao": "Alagáveis" },
        { "grupo": "Topografia", "descricao": "Rochosas" },
        { "grupo": "Destinação", "descricao": "Inaproveitável" },
        { "grupo": "Destinação", "descricao": "Outra Utilização" }
    ],
    [
        { "grupo": "Topografia", "descricao": "Plano" },
        { "grupo": "Topografia", "descricao": "Alagado" },
        { "grupo": "Topografia", "descricao": "Caído" },
        { "grupo": "Topografia", "descricao": "Inaproveitável" },
        { "grupo": "Destinação", "descricao": "Agricultura" },
        { "grupo": "Destinação", "descricao": "Pecuária" },
        { "grupo": "Destinação", "descricao": "Mato" },
        { "grupo": "Destinação", "descricao": "Reflorestamento" },
    ],

    [
        { "grupo": "Utilização", "descricao": "Agricultura" },
        { "grupo": "Utilização", "descricao": "Mato" },
        { "grupo": "Utilização", "descricao": "Pecuária" },
        { "grupo": "Utilização", "descricao": "Reflorestamento" },
        { "grupo": "Relevo", "descricao": "Plano" },
        { "grupo": "Relevo", "descricao": "Alagado" },
        { "grupo": "Relevo", "descricao": "Caído" },
        { "grupo": "Relevo", "descricao": "Inaproveitável" },
    ],

]

export const Municipio_Formulario = [
    { id: 19, nome: "vila", formulario: 1 }, { id: 24, nome: "são josé", formulario: 1 },
    { id: 6, nome: "sananduva", formulario: 2 }, { id: 31, nome: "trindade", formulario: 2 },
    { id: 8, nome: "cacique", formulario: 2 }, { id: 16, nome: "ibiaca", formulario: 2 },
    { id: 15, nome: "herveiras", formulario: 2 },
    { id: 12, nome: "erval grande", formulario: 4},
    { id: 2, nome: "teste", formulario: 3 },
]